import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { HashLoader } from 'react-spinners';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { AfterEffectsChapterType } from 'stageclip-common';

import AppModal from '../../../modal/appModal';
import { FormId } from '../../../../constants/formId';
import { SimpleModalId } from '../../../../constants/modalId';
import { AppFileField } from '../../../form/appFileField';
import { AppSelectField } from '../../../form/appSelectField';
import { required, requiredString } from '../../../form/formValidations';
import {
  CreateChapterFormDataProps,
  CreateChapterFormOnSubmitProps,
  CreateChapterFormOwnProps,
  ChapterFormFieldsProps,
} from '../chapter.types';
import { allowedImageExtensions, allowedVideoExtensions, validateVideoOrImageFile } from '../../utils/fileValidators';
import styles from '../../ClipGeneratorPage.module.scss';

export const chapterTypeOptions = [
  {
    value: AfterEffectsChapterType.Video,
    label: AfterEffectsChapterType.Video,
  },
  {
    value: AfterEffectsChapterType.Image,
    label: AfterEffectsChapterType.Image,
  },
  {
    value: AfterEffectsChapterType.TemplatePreRoll,
    label: AfterEffectsChapterType.TemplatePreRoll,
  },
  {
    value: AfterEffectsChapterType.TemplatePostRoll,
    label: AfterEffectsChapterType.TemplatePostRoll,
  },
];

const ChapterFormFields = ({ orderIndexOptions }: ChapterFormFieldsProps) => (
  <>
    <AppSelectField name="orderIndex" label="Order Index" options={orderIndexOptions} validate={[required]} />
    <AppSelectField
      name="chapterType"
      key="chapterType"
      label="Chapter Type"
      options={chapterTypeOptions}
      validate={[required, requiredString]}
    />
    <AppFileField
      name="asset"
      label="Asset"
      extensions={allowedImageExtensions.concat(allowedVideoExtensions)}
      validate={validateVideoOrImageFile}
    />
  </>
);

const CreateChapterForm = ({
  form,
  handleSubmit,
  orderIndexOptions,
  isLoading,
  onSubmit,
}: CreateChapterFormOwnProps) => {
  const handleOnSubmit = (values: CreateChapterFormDataProps) => onSubmit(values);

  return (
    <AppModal
      form={form}
      title="Create Chapter"
      id={SimpleModalId.CreateAfterEffectsChapterModal}
      buttonIcon={faUserPlus}
      hideActionButtons={isLoading}
      className={styles.modal}
    >
      {isLoading ? (
        <div className={styles.loader}>
          <HashLoader />
        </div>
      ) : (
        <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
          <ChapterFormFields orderIndexOptions={orderIndexOptions} />
        </Form>
      )}
    </AppModal>
  );
};

export const CreateChapterFormContainer = reduxForm<CreateChapterFormDataProps, CreateChapterFormOnSubmitProps>({
  form: FormId.CreateAfterEffectsChapterForm,
  enableReinitialize: true,
})(CreateChapterForm);
